/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FileTypeFromJSON, FileTypeToJSON, } from './';
export function OrderedFileDtoFromJSON(json) {
    return OrderedFileDtoFromJSONTyped(json, false);
}
export function OrderedFileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fileId': !exists(json, 'fileId') ? undefined : json['fileId'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'urlThumbnail': !exists(json, 'urlThumbnail') ? undefined : json['urlThumbnail'],
        'type': !exists(json, 'type') ? undefined : FileTypeFromJSON(json['type']),
        'contentType': !exists(json, 'contentType') ? undefined : json['contentType'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'order': !exists(json, 'order') ? undefined : json['order'],
    };
}
export function OrderedFileDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fileId': value.fileId,
        'fileName': value.fileName,
        'url': value.url,
        'urlThumbnail': value.urlThumbnail,
        'type': FileTypeToJSON(value.type),
        'contentType': value.contentType,
        'size': value.size,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'order': value.order,
    };
}
